import { connect } from 'react-redux';
import { getCurrentAdSafety } from '../../../../Ads/redux/selectors';
const mapStateToProps = (state)=>({
        adSafety: getCurrentAdSafety(state) || 'off'
    });
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps);
